// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS202: Simplify dynamic range loops
 * DS205: Consider reworking code to avoid use of IIFEs
 * DS206: Consider reworking classes to avoid initClass
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import * as d3 from 'd3';
import {Selection} from 'd3';

import * as selectioncontextmenu from 'components/SelectionContextMenu';
import * as context from 'Context';
import arcs, {BenchlingArc} from 'molbio/maps/circular/Arcs';
import {RingLayout} from 'molbio/maps/circular/CircularLayout';
import {GenericArcDatum} from 'molbio/maps/circular/CircularMapTypedefs';
import {getArcForStrand} from 'molbio/maps/circular/CircularUtil';
import SegmentsRingView, {SegmentRingSelection} from 'molbio/maps/circular/SegmentsRingView';
import {SequenceMapPreferences} from 'molbio/maps/SequenceMapConstants';
import * as sequtil from 'molbio/SeqUtil';
import ORF from 'molbio/translations/backbone/ORF';
import preferences from 'Preferences';

interface HasRadius {
  innerRadius: number;
  outerRadius: number;
}

class CircularORFsView extends SegmentsRingView<RingLayout, ORF> {
  className!: string;
  singularClassName!: string;

  static initClass(): void {
    this.prototype.className = 'orfs';
    this.prototype.singularClassName = 'orf';
    this.prototype.tagName = 'g';
  }

  contextMenuData(): Array<string> {
    return selectioncontextmenu.getSelectionMenu();
  }

  fill(d: ORF): string {
    if (d.get('hover') || d.selected()) {
      return d3.rgb(d.color()).darker().formatHex();
    } else {
      return d.color();
    }
  }

  opacity(d: ORF): number {
    return 1.0;
  }
  strokeWidth(d: ORF): number {
    return 1.0;
  }
  stroke(d: ORF): string {
    return d.color();
  }

  handleHover(model: ORF, value: unknown): unknown {
    const id = model.uid();
    const root = d3.select(this.el).selectAll('.individual-ring').filter(`[id='${id}']`);
    // eslint-disable-next-line @typescript-eslint/unbound-method
    root.select('.line').transition().duration(25).attr('fill-opacity', this.opacity).attr('fill', 'none');

    return (
      root
        .selectAll('.start-position')
        .transition()
        .duration(25)
        // eslint-disable-next-line @typescript-eslint/unbound-method
        .attr('fill-opacity', this.opacity)
        // eslint-disable-next-line @typescript-eslint/unbound-method
        .attr('fill', this.fill)
    );
  }

  // @ts-expect-error: Improperly extends super interface
  handleDraw(selector: Selection<SVGGElement, ORF, SVGGElement, unknown>, d: ORF): void {
    let end;
    let i;
    const sequence = this.model.get('sequence');
    const line = selector.selectAll('.line');

    const setArcValues = (
      arc: d3.Arc<unknown, ORF>,
      radius: HasRadius,
      angles: GenericArcDatum
    ): d3.Arc<unknown, ORF> =>
      arc
        .innerRadius(radius.innerRadius)
        .outerRadius(radius.outerRadius)
        .startAngle(angles.startAngle)
        .endAngle(angles.endAngle);

    line.data([d]);
    line.attr(
      'd',
      ((ref) =>
        function (d: ORF) {
          const arc = arcs.linearArc();

          const layer = d.get('annularLayer');
          const angles = ref.getAngles(d.start(), d.end());
          const radius = ref.lineBounds(layer);
          (arc.radius(radius) as BenchlingArc<unknown>)
            .startAngle(angles.startAngle)
            .endAngle(angles.endAngle)
            .reverse(false);

          // @ts-expect-error: Missing arg
          return arc();
        })(this)
    );

    const background = selector.selectAll('.hidden-background');
    background.attr(
      'd',
      ((ref) =>
        function (d: ORF) {
          const layer = d.get('annularLayer');
          const angles = ref.getAngles(d.start(), d.end());
          const arc = ref.arc(d) as d3.Arc<unknown, ORF>;
          const radius = ref.backgroundBounds(layer);
          setArcValues(arc, radius, angles);
          return arc(d);
        })(this)
    );

    const starts = d.startPositions();
    // @ts-expect-error: Unused variable
    const ends = d.endPosition() != null ? [d.endPosition()] : [];

    const dataArray = (() => {
      const result = [];
      for (i = 0; i < starts.length; i++) {
        result.push(d);
      }
      return result;
    })();
    const positions = selector.selectAll('path.start-position').data(dataArray);
    positions
      .enter()
      .append('svg:path')
      .classed('start-position', true)
      .classed('layer-fill', true)
      // eslint-disable-next-line @typescript-eslint/unbound-method
      .attr('fill', this.fill)
      // eslint-disable-next-line @typescript-eslint/unbound-method
      .attr('fill-opacity', this.opacity)
      .attr('shape-rendering', 'geometricPrecision')
      // eslint-disable-next-line @typescript-eslint/unbound-method
      .attr('stroke-width', this.strokeWidth)
      .attr('stroke', 'green');
    const length = 2 * Math.PI * (3 / sequence.length()) * this.layout.get('innerRadius');

    const THRESHOLD = 3;
    if (length > THRESHOLD) {
      positions.attr(
        'd',
        ((ref) =>
          function (d: ORF, i: number) {
            let start;
            const layer = d.get('annularLayer');
            if (d.strand() === 1) {
              start = starts[i];
              end = sequtil.mod(start + 3, sequence.length());
            } else {
              end = (starts[i] + 1) % sequence.length();
              start = sequtil.mod(end - 3, sequence.length());
            }
            const angles = ref.getAngles(start, end);
            const arc = getArcForStrand(d.strand()) as d3.Arc<unknown, ORF>;
            const radius = ref.layerBounds(layer);
            setArcValues(arc, radius, angles);
            return arc(d);
          })(this)
      );
    } else {
      positions.attr(
        'd',
        ((ref) =>
          function (d: ORF, i: number) {
            const layer = d.get('annularLayer');
            let position = starts[i];
            if (d.strand() === -1) {
              position = (position + 1) % sequence.length();
            }
            const angles = ref.getAngles(position, position + 0.1);
            const arc = d3.arc() as unknown as d3.Arc<unknown, ORF>;
            const radius = ref.layerBounds(layer);
            setArcValues(arc, radius, angles);
            return arc(d);
          })(this)
      );
    }

    positions.exit().remove();
    // eslint-disable-next-line @typescript-eslint/no-confusing-void-expression
    return this.registerPieceHandlers(selector);
  }

  pieceClickHandler(e: Event, d: ORF): void {
    const index = this.circularView.getHoverBase(e, false);
    // eslint-disable-next-line @typescript-eslint/no-confusing-void-expression
    return context.using({isLinear: this.isLinear, mapId: this.model.cid, index}, this, function () {
      // @ts-expect-error: Shadowing of this
      return this.clickAction(e, d);
    });
  }

  pieceDblClickHandler(e: Event, d: ORF): void {
    const index = this.circularView.getHoverBase(e, false);
    // eslint-disable-next-line @typescript-eslint/no-confusing-void-expression
    return context.using({isLinear: this.isLinear, mapId: this.model.cid, index}, this, function () {
      // @ts-expect-error: Shadowing of this
      return this.dblClickAction(e, d);
    });
  }

  enterRing(enter: SegmentRingSelection<ORF>): SegmentRingSelection<ORF> {
    const ring = enter.append('svg:g').classed('ring-shape', true).merge(enter) as SegmentRingSelection<ORF>;
    ring
      .append('svg:path')
      .classed('line', true)
      .classed(this.singularClassName, true)
      // eslint-disable-next-line @typescript-eslint/unbound-method
      .attr('stroke-width', this.strokeWidth)
      // eslint-disable-next-line @typescript-eslint/unbound-method
      .attr('stroke', this.stroke)
      .attr('shape-rendering', 'geometricPrecision')
      .attr('fill', 'none')
      // eslint-disable-next-line @typescript-eslint/unbound-method
      .attr('fill-opacity', this.opacity);

    ring.append('svg:path').classed('hidden-background', true).attr('fill-opacity', 0);

    return ring;
  }

  data(): Array<ORF> {
    const sequence = this.model.get('sequence');
    const length = sequence.length();
    // TODO: Use preference values here. Right now it doesn't matter because visibility options will
    // trigger another re-render with updated values for all options, but they will be incorrect on the first
    // render which will cause an error in `sliceAndFilter` (which depends on `startCodon`).
    const option = this.tabstate.get('visibilityOptions').getOption('orfs');
    const minLength = option!.getSetting('minimum-orf-length')!.get('value');
    const frame = option!.getSetting('orf-frame')!.get('value');
    // Generally visibility options control what data is rendered (and when to re-render), but visibility
    // options are also synced to preferences which is why we can use that here.
    const startCodon = preferences.get(SequenceMapPreferences.ORF_START_CODON);
    const options = {minLength, frame, sequence, startCodon};
    const orfs = sequence.get('orfs').sliceAndFilter(0, length, options);
    return orfs;
  }

  registerListeners(): void {
    super.registerListeners();

    const orfs = this.model.get('sequence').get('orfs');
    // eslint-disable-next-line @typescript-eslint/unbound-method
    this.listenTo(orfs, 'change:hover change:selected', this.handleHover);
    // eslint-disable-next-line @typescript-eslint/unbound-method
    return this.listenTo(orfs, 'click', this.pieceClickHandler);
  }

  setConstraints(outerRadius: number): void {
    // eslint-disable-next-line @typescript-eslint/no-confusing-void-expression
    return this.setOuterRadius(outerRadius);
  }

  clickAction(e: Event, d: ORF): void {
    // eslint-disable-next-line @typescript-eslint/no-confusing-void-expression
    return d.click(this.model.get('sequence'), false);
  }

  dblClickAction(e: Event, d: ORF): void {
    // eslint-disable-next-line @typescript-eslint/no-confusing-void-expression
    return d.dblClick(this.model.get('sequence'), false);
  }

  redraw(): void {
    this.invalidateData();
    // eslint-disable-next-line @typescript-eslint/no-confusing-void-expression
    return super.redraw();
  }

  redrawPlasmid(): boolean {
    return true;
  }

  storeBounds(rings: number | null | undefined): void {
    if (rings == null) {
      ({rings} = this);
    }
    this.rings = rings;
    const innerRadius = this.getOuterRadius() - this.layout.get('ringHeight') * this.rings!;
    this.layout.set('innerRadius', innerRadius);
    // eslint-disable-next-line @typescript-eslint/no-confusing-void-expression
    return this.updateRadius();
  }

  zeroBounds(): void {
    this.layout.set('innerRadius', this.layout.get('outerRadius'));
    // eslint-disable-next-line @typescript-eslint/no-confusing-void-expression
    return this.updateRadius();
  }

  lineBounds(layer: number): number {
    const layerBounds = this.layerBounds(layer);
    return (layerBounds.innerRadius + layerBounds.outerRadius) / 2;
  }

  backgroundBounds(layer: number): {innerRadius: number; outerRadius: number} {
    return {
      innerRadius: this.radiusIn(layer + 1),
      outerRadius: this.radiusIn(layer + 0.1),
    };
  }

  layerBounds(layer: number): HasRadius {
    return {
      innerRadius: this.radiusIn(layer + 1),
      outerRadius: this.radiusIn(layer) - this.layout.vMargin(),
    };
  }

  baseLine(layer: number, innerRadius: number | null = null): number {
    if (innerRadius != null) {
      // @ts-expect-error: unused arg
      return super.baseLine(layer, innerRadius);
    } else {
      return this.radiusIn(layer + 1);
    }
  }
}
CircularORFsView.initClass();

export default CircularORFsView;
